import DriTransactionRates from './DriTransactionRates';

export default DriTransactionRates;
